module.exports = __webpack_public_path__ + "files/30547abbe3181a591fd8bc8e2eee1873.png";